<template>
    <div>
        <template>
            <v-card tile elevation="0">
                <div class="contents-area__inner">
                    <v-row>
                        <!-- 상품 이미지 -->
                        <v-col cols="12" md="5">
                            <v-layout wrap justify-center>
                                <v-responsive max-width="480" :aspect-ratio="1/1">
                                    <v-carousel height="auto" hide-delimiters show-arrows-on-hover :show-arrows="1 < value?.images?.length">
                                        <v-carousel-item v-for="image, index in value?.images || []" :key="index">
                                            <v-img :src="images[index]" width="100%" contain :aspect-ratio="1" />
                                        </v-carousel-item>
                                    </v-carousel>
                                </v-responsive>
                            </v-layout>
                        </v-col>

                        <!-- 상품정보 -->
                        <v-col cols="12" md="7">
                            <div class="pl-md-10">

                                <!-- 제품명 -->
                                <template>
                                    <div class="tit-wrap mb-20px mb-md-30px">
                                        <div class="tit tit--sm primary--text">
                                            <p v-html="value.name"/>
                                        </div>
                                    </div>
                                </template>

                                <v-divider />

                                <!-- 판매가 -->
                                <div class="py-10px py-md-16px">
                                    <template>
                                        <product-info-field label="판매가" class="font-weight-medium">
                                            <v-row no-gutters align="center">
                                                <v-col cols="auto">
                                                    <span v-if="value?.costPrice && value?.costPrice != value?.salePrice" class="red--text text-decoration-line-through body-2 mr-2">{{ parseInt(value?.costPrice).format() }} 원</span>
                                                </v-col>
                                                <v-col>
                                                    <div class="d-inline-flex align-center font-size-18 font-size-md-20 line-height-1">
                                                        <b>{{ parseInt(value?.salePrice).format() }}</b><span class="font-size-16 ml-2px">원</span>
                                                    </div>
                                                </v-col>
                                            </v-row>
                                        </product-info-field>
                                    </template>
                                </div>

                                <v-divide />
                                <div class="py-10px py-md-16px">
                                    <template v-if="value?.writer">
                                        <product-info-field label="저자">{{value.writer}}</product-info-field>
                                    </template>

                                    <template v-if="value?.publisher">
                                        <product-info-field label="출판사">{{value.publisher}}</product-info-field>
                                    </template>

                                    <!-- <template>
                                        <product-info-field label="적립금" class="mt-4"><b>{{ parseInt(0).format() }}</b> 원</product-info-field>
                                    </template> -->

                                    <template>
                                        <product-info-field label="배송비">
                                        <span v-if="value.shippingCode === 'later'"><b>착불배송</b></span>
                                        <span v-if="value.shippingCode === 'self'"><b>{{ parseInt(value.shippingPrice).format() }}</b> 원</span>
                                        <span v-if="value.shippingCode === 'free'"><b>배송비 무료</b></span>
                                        <span v-if="value.shippingCode === 'order'" class="font-size-14 text-end"><b>{{`${setting?.shippingPrice?.lt.format()}원 (${setting?.saleAmount?.format()}원 이상은 무료배송)`}}</b></span>
                                        </product-info-field>
                                    </template>

                                    <template>
                                        <product-info-field label="배송일정">
                                            <div class="grey--text text--darken-2">
                                                <div>* 당일 13시까지 주문건에 한하여, 당일 출고됩니다.</div>
                                                <div> 택배사 일정에 따라 2~3일 소요될 수 있습니다. (도서산간 제외)</div>
                                            </div>
                                        </product-info-field>
                                    </template>

                                    <template>
                                        <product-info-field v-for="(item, index) in value.info" :label="item.name" class="mt-4" :key="index">
                                            <span v-if="item"><b>{{item.value}}</b></span>
                                        </product-info-field>
                                    </template>
                                </div>

                                <!-- PC 수량 레이아웃 : 옵션상품 사용할때-->
                                <template  v-if="value.optionalProducts?.length">
                                    <v-divider />
                                    <div class="py-10px py-md-16px">
                                        <optional-products v-model="carts" :product="value" @carts="cart => carts = cart "/>
                                    </div>
                                </template>

                                <!-- PC 수량 레이아웃 : 재고가 없을때-->
                                <template v-if="!value.stock || value.soldout || value.stock === '0'">
                                    <v-divider />
                                    <div class="py-10px py-md-16px">
                                        <product-info-field label="수량" class="mt-4 font-weight-bold">품절</product-info-field>
                                    </div>
                                </template>

                                <v-divider />

                                <!-- PC 수량 레이아웃 : 재고가 있을때 -->
                                <template v-if="carts.length && !value.soldout && value.stock !== '0'">
                                    <div class="py-10px py-md-16px">
                                        <cart-list v-model="carts"/>
                                    </div>

                                    <v-divider />
                                    <div class="py-10px py-md-16px">
                                        <v-row align="center" class="row--small font-size-14">
                                            <v-col cols="3" md="2">
                                                총 합계
                                            </v-col>
                                            <v-col cols="9" md="10">
                                                <div class="d-inline-flex align-center font-size-18 font-size-md-24">
                                                    <b class="primary--text">{{ parseInt(totalAmount).format() }}</b>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </div>

                                    <v-divider class="border-2"/>
                                    <div class="py-10px py-md-16px">
                                        <v-row align="center" class="row--x-small">
                                            <v-col>
                                                <v-btn block tile x-large outlined color="grey">
                                                    <v-icon class="mr-10px grey--text text--darken-3">mdi-gift-outline</v-icon><span class="grey--text text--darken-3">선물하기</span>
                                                </v-btn>
                                            </v-col>
                                            <v-col>
                                                <v-btn block tile x-large color="secondary"><v-icon class="mr-10px">mdi-cart-outline</v-icon>장바구니</v-btn>
                                            </v-col>
                                            <v-col>
                                                <v-btn block tile x-large color="primary"><v-icon class="mr-10px">mdi-shopping-outline</v-icon>바로구매</v-btn>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </template>
                            </div>
                        </v-col>
                    </v-row>

                    <v-divider class="d-none d-lg-block"/>

                    <!-- 이전상품·다음상품 레이아웃 -->
                    <div class="pt-10px pt-md-16px">
                        <v-row class="row--x-small">
                            <v-col cols="auto">
                                <v-btn small outlined color="grey">
                                    <span class="d-flex align-center grey--text text--darken-3"><v-icon small class="mr-4px mr-md-10px">mdi-chevron-left</v-icon>이전상품보기</span>
                                </v-btn>
                            </v-col>
                            <v-spacer />
                            <v-col cols="auto">
                                <v-btn small outlined color="grey">
                                    <span class="d-flex align-center grey--text text--darken-3">다음상품보기<v-icon small class="ml-4px ml-md-10px">mdi-chevron-right</v-icon></span>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-card>

            <v-divider/>
                

        <v-responsive>
            <v-card>
                <v-tabs show-arrows grow class="pa-0">
                    <v-tab class="pa-0"><v-btn text block tile height="100%">기대평/리뷰</v-btn></v-tab>
                    <v-tab class="pa-0"><v-btn text block tile height="100%">상품문의</v-btn></v-tab>
                    <v-tab class="pa-0"><v-btn text block tile height="100%">상품정보</v-btn></v-tab>
                    <v-tab class="pa-0"><v-btn text block tile height="100%">교환/환불/배송</v-btn></v-tab>
                </v-tabs>

                <div id="product-content" class="mt-4 pt-12"></div>
                <v-responsive >
                    <v-card-text class="mt-4">
                        <v-img src="/images/products/gift-guide.jpg" />
                        <p v-html="value?.content" class="pa-4"></p>
                    </v-card-text>
                </v-responsive>
            </v-card>
        </v-responsive>

        </template>

        <!-- Mobile 하단 네비게이션 -->
        <template v-if="$vuetify.breakpoint.mobile && ready" slot="fab" slot-scope="{showScroll, scrollTo}">
            <v-app-bar app bottom height="auto" color="transparent" elevation="0">
                <v-responsive class="overflow-visible">
                    <!-- Top 버튼 -->
                    <v-btn v-show="showScroll" fab absolute top right large tile color="primary" class="mt-n40px" @click="scrollTo(0,0)">
                        <div class="pa-12px">
                            <v-icon size="20" class="my-n4px">mdi-chevron-up</v-icon>
                            <div class="font-size-14 font-weight-medium mb-6px">TOP</div>
                        </div>
                    </v-btn>

                    <v-card elevation="0">
                        <div>
                            <v-btn block slot="extension" @click="expand = !expand" text large height="32" :ripple="false" active-class="no-active">
                                <v-icon v-show="!expand">mdi-chevron-up</v-icon>
                                <v-icon v-show="expand">mdi-chevron-down</v-icon>
                            </v-btn>
                        </div>

                        <!-- <v-expand-transition>
                            <v-responsive v-show="expand" elevation="0"> -->

                                <!-- PC 수량 레이아웃 : 옵션상품 사용할때-->
                                <!-- <template v-if="value?.optionalProducts?.length">
                                    <v-divider class="mb-4"/>
                                    <optional-products v-model="carts" :product="value" class="px-4" />
                                </template>

                                <template v-if="carts.length">
                                    <v-divider class="my-4"/>
                                    <cart-list v-model="carts" class="px-4"/>
                                </template>

                                <v-divider class="my-4"/>
                                <v-layout class="px-4 mb-4">
                                    <v-flex grow-shrink-0>
                                        <span class="tit tit--xs">총 합계</span>
                                    </v-flex>
                                    <v-spacer />
                                    <v-flex grow-shrink-0>
                                        <span class="tit tit--xs"><b class="primary--text">{{ parseInt(totalAmount).format() }}</b> 원</span>
                                    </v-flex>
                                </v-layout>
                            </v-responsive>
                        </v-expand-transition> -->

                        <v-divider/>

                        <v-card-actions>
                            <v-layout class="py-1">
                                <v-flex grow-shrink-0 class="px-1">
                                    <v-btn color="primary" min-width="auto" x-large class="px-4" outlined @click="addToCart"><v-icon>mdi-cart-outline</v-icon></v-btn>
                                </v-flex>
                                <v-flex grow-shrink-0 class="px-1">
                                    <v-btn color="primary" min-width="auto" x-large class="px-4" outlined @click="gift"><v-icon>mdi-gift-outline</v-icon></v-btn>
                                </v-flex>
                                <v-flex class="px-1">
                                    <v-btn block color="primary" x-large @click="order"><span class="tit tit--xs white--text"><v-icon class="mr-2 ml-n4">mdi-shopping-outline</v-icon>구매하기</span></v-btn>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                    </v-card>
                </v-responsive>
            </v-app-bar>
        </template>
    </div>
</template>
<script>
import { mdiChevronUp, mdiChevronDown, mdiChevronLeft, mdiChevronRight, mdiPlusCircleMultipleOutline, mdiCartOutline, mdiGiftOutline, mdiShoppingOutline } from "@mdi/js";

import LoginDialog from "@/components/client/login/login-dialog.vue";
import ProductInfoField from "@/components/client/shop/product/product-info-field.vue";
import CartList from "@/components/client/shop/product/cart-list.vue";
import OptionalProducts from "@/components/client/shop/product/optional-products.vue";
import ReviewList from "@/components/client/shop/product/review-list.vue";
import InquiryList from "@/components/client/shop/product/inquiry-list.vue";
import ExpectationList from "@/components/client/shop/product/expectation-list.vue";
import api from "@/api"

export default {
    components: {
        LoginDialog,
        ProductInfoField,
        CartList,
        OptionalProducts,
        ReviewList,
        InquiryList,
        ExpectationList,
    },
    props: {
        value: {
            type: Object
        }
    },
    data(){
        return {
            // 아이콘
            mdiCartOutline,
            mdiGiftOutline,
            mdiChevronUp,
            mdiChevronDown,
            mdiChevronLeft,
            mdiChevronRight,
            mdiShoppingOutline,
            mdiPlusCircleMultipleOutline,

            carts: [], // 수량

            setting: null
        }
    },
    mounted(){
        this.init()
    },
    methods: {
        async init(){
            this.$nextTick(() => {
                this.carts = []
                if(this.value.type == "main" && this.value.stock && !this.value?.optionalProducts?.length){
                    this.carts.push({ product: this.value, quantity: 1});
                }
            })

            let { setting } = await api.v1.shop.setting.get();
            this.setting = setting;
        }
    },
    computed: {
        images(){
            let images = new Array(this.value.images.length);
            for(var i in this.value.images){
                try{
                    images[i] = URL.createObjectURL(this.value.images[i]);
                }
                catch(error){}
            }
            return images;
        },
        saleAmount(){
            return this.carts.reduce((saleAmount, cart) => {
                console.log(saleAmount, cart)
                return saleAmount += cart?.product?.salePrice * cart?.quantity;
            }, 0)
        },
        shippingAmount(){
            return this.value?.shippingPrice;
        },
        totalAmount(){
            return this.saleAmount
        }
    },
    watch: {
        'value.stock'(){
            this.init()
        }
    }
}
</script>

<style scoped>
.v-app-bar {
    height: auto !important;
}
.v-app-bar >>> .v-toolbar__content {
    padding: 0 !important;
    height: auto !important;
}
.v-btn--active.no-active::before {
  opacity: 0 !important;
}
.v-card__text {
    color: black !important;
}
.product-view .product-name {
    font-size: 32px;
    font-weight: 500;
}
.product-view .product-description {
    font-size: 13px;
}
.product-view .product-content >>> img {
    max-width: 100%;
    height: auto;
}
.product-view .product-notification >>> img {
    max-width: 100%;
    height: auto;
}
.product-view >>> input {
    text-align: end;
}
</style>